// src/components/sku/SkuFilterBar.tsx
import React from "react";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import type { SkuType } from "src/types/sku";

type Props = {
  skuName: string;
  onChangeSkuName: (v: string) => void;

  skuType: SkuType;
  size: number;
  order: string;

  onChangeImmediate: (patch: Partial<{ skuType: SkuType; size: number; order: string }>) => void;

  onSearch: () => void;
  onReset: () => void;
  onCreate: () => void;
};

export default function SkuFilterBar({
  skuName,
  onChangeSkuName,
  skuType,
  size,
  onChangeImmediate,
  onSearch,
  onReset,
  onCreate,
}: Props) {
  return (
    <Paper
      elevation={0}
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        p: 2,
      }}
    >
      <Stack
        direction="row"
        spacing={1.5}
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        {/* ===== 좌측: 필터 영역 ===== */}
        <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap">
          <TextField
            size="small"
            label="SKU명 검색"
            value={skuName}
            onChange={(e) => onChangeSkuName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") onSearch();
            }}
            sx={{ minWidth: 260 }}
          />

          <FormControl size="small" sx={{ minWidth: 160 }}>
            <InputLabel id="skuType-label">skuType</InputLabel>
            <Select
              labelId="skuType-label"
              label="skuType"
              value={skuType}
              onChange={(e) => onChangeImmediate({ skuType: e.target.value as SkuType })}
            >
              <MenuItem value="PRODUCT">PRODUCT</MenuItem>
            </Select>
          </FormControl>

          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel id="size-label">size</InputLabel>
            <Select
              labelId="size-label"
              label="size"
              value={size}
              onChange={(e) => onChangeImmediate({ size: Number(e.target.value) })}
            >
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </FormControl>
        </Stack>

        {/* ===== 우측: 액션 버튼 ===== */}
        <Stack direction="row" spacing={1} alignItems="center">
          <Button variant="contained" onClick={onSearch}>
            검색
          </Button>
          <Button variant="outlined" onClick={onReset}>
            초기화
          </Button>
          <Button variant="contained" color="primary" onClick={onCreate}>
            + SKU 등록
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
}
